import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Note2 = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 20 }, forwardedRef) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 22 22" fill="none">
      <path
        d="M8.23538 15.7688C7.92936 15.1023 6.67593 14.1293 6.36404 13.9889C5.65056 13.5901 4.8211 13.4303 4.00428 13.5344C3.18747 13.6385 2.42895 14.0006 1.84636 14.5645C1.26377 15.1285 0.88967 15.8627 0.782066 16.6535C0.674462 17.4442 0.839372 18.2472 1.25122 18.938C1.66307 19.6288 2.29884 20.1687 3.05995 20.474C3.82105 20.7793 4.66495 20.833 5.46077 20.6267C6.25659 20.4204 6.95987 19.9657 7.46153 19.333C7.96319 18.7003 8.23521 17.9251 8.23539 17.1275V4.37309C8.23539 3.90561 8.55928 3.5005 9.0153 3.39761L20.75 0.75L20.7499 14.5417M20.7499 14.5417L20.75 15.9006C20.7498 16.6982 20.4778 17.4734 19.9761 18.1061C19.4745 18.7388 18.7712 19.1935 17.9754 19.3998C17.1796 19.6061 16.3357 19.5524 15.5746 19.2471C14.8135 18.9418 14.1777 18.4019 13.7658 17.7111C13.354 17.0203 13.1891 16.2173 13.2967 15.4266C13.4043 14.6358 13.7784 13.9016 14.361 13.3376C14.9436 12.7737 15.7021 12.4116 16.5189 12.3075C17.3357 12.2034 18.1652 12.3632 18.8787 12.762C19.1905 12.9024 20.4437 13.8752 20.7499 14.5417Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
})

export default Note2
